/* Detecta cuando el slideshow de categorías está en viewport
   y agrega la clase `over-slideshow-categories` al body para que
   el header se vuelva transparente y se mezcle con la imagen. */
(function () {
  function init() {
    var section = document.querySelector('[id*="section_slideshow_categories"]');
    if (!section || typeof IntersectionObserver === 'undefined') return;

    var headerHeight = (function () {
      var h = document.querySelector('[data-site-header]');
      return h ? h.offsetHeight : 80;
    })();

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.25) {
            document.body.classList.add('over-slideshow-categories');
          } else {
            document.body.classList.remove('over-slideshow-categories');
          }
        });
      },
      {
        rootMargin: '-' + headerHeight + 'px 0px 0px 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    observer.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
